import { MediaDocument } from '../media-document/media-document.model';
export class MediaContactDocument {
    __originalDocument__: any;
    id: string;

    firstName: string;
    middleName: string;
    lastName: string;
    fullName: string;
    jobTitle: string;
    addresses: MediaContactAddress[];
    primaryAddress: MediaContactAddress;
    emails: MediaContactEmailType[];
    phoneNumbers: MediaContactPhoneNumber[];
    socialProfiles: MediaContactSocialProfile[];
    channels: MediaContactChannel[];
    beats: MediaContactBeat[];
    notes: string[];
    relevantArticlesCount: number;
    selected: boolean = false;
    sources: MediaContactSource[];
    primarySource: MediaContactSource;
    title: string;
    titleUrl: string;
    description: string;
    totalGroups: number;
    documents: MediaDocument[];
    engagement: MediaContactEngagement;
    lists: string[];

    constructor(originalDoc?: any) {
        this.__originalDocument__ = originalDoc;
    }
}

export interface MediaContactAddress {
    type?: MediaContactAddressType,
    street?: string,
    street2?: string,
    city?: string,
    zip?: string,
    countryName?: string,
    stateOrProvince?: string,
    primary: boolean
}

export interface MediaContactPhoneNumber {
    type: MediaContactPhoneNumberType,
    number: string
}

export interface MediaContactEmail {
    type: MediaContactEmailType,
    address: string
}

export interface MediaContactBeat {
    id: string,
    name: string
}

export interface MediaContactSocialProfile {
    type: MediaContactSocialProfileType,
    url: string
}

export interface MediaContactChannel {
    id: string,
    name: string,
    type: MediaContactChannelType
}

export interface MediaContactSource {
    id: string,
    name: string,
    primary: boolean,
    url: string,
    contactUrl: string
}

export interface MediaContactEngagement{
    emailsSent: number,
    openRate: number,
    clickRate: number
}

// see addressTypes from contact_manager_property_type_service in icm-web
export enum MediaContactAddressType {
    Personal = 'personal',
    Work = 'work',
    Other = 'other'
}

// see emailTypes from contact_manager_property_type_service in icm-web
export enum MediaContactEmailType {
    Personal = 'personal',
    Work = 'work',
    Other = 'other'
}

// see phoneNumberTypes from contact_manager_property_type_service in icm-web
export enum MediaContactPhoneNumberType {
    Mobile = 'mobile',
    Home = 'home',
    Work = 'work',
    Fax = 'fax',
    Other = 'other'
}

// see FairhairSocialProfileTypes from contact_manager_property_type_service in icm-web
export enum MediaContactSocialProfileType {
    Facebook = 'facebook',
    Twitter = 'twitter',
    Linkedin = 'linked_in',
    Xing = 'xing',
    Other = 'other'
}

// see FairhairChannelTypes from contact_manager_property_type_service in icm-web
export enum MediaContactChannelType {
    Website = 'website',
    Source = 'source',
    Social = 'social'
}

export enum MediaContactBeatType {
    Personal = 'personal',
    Work = 'work',
    Other = 'other'
}



/**********************************************************************************/
/****** EVERYTHING BELOW IS JUST FOR REFERENCE, SHOULD EVENTUALLY BE DELETED ******/

// This is the contact data model that is fetched from server https://app.meltwater.com/api/icm-css/search/relevantContacts
let sampleFromContactSearch = {
    'systemData': {
    },
    'contactInfo': {
        'addresses': [
            {
                'city': 'New York',
                'stateOrProvince': 'New York',
                'country': 'United States'
            }
        ],
        'email': [
            {
                'address': 'ratepper@gmail.com'
            }
        ]
    },
    'channels': [
        {
            'type': 'social',
            'socialProfile': {
                'type': 'linked_in',
                'url': 'https://www.linkedin.com/in/rachel-tepper-paley-0a40609'
            }
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'twitter',
                'url': 'https://twitter.com/racheltepper'
            }
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'facebook',
                'url': 'https://www.facebook.com/racheltepper'
            }
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'instagram',
                'url': 'https://www.instagram.com/thepumpernickel/?hl=en'
            }
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'googleplus',
                'url': 'https://plus.google.com/113424597791865604922'
            }
        }
    ],
    'roles': [

    ],
    'name': {
        'firstName': 'Rachel',
        'lastName': 'Tepper Paley'
    },
    'description': '',
    'beats': [
        {
            'id': '33f6bff2-6c51-4b18-9712-e2d5ed85e267',
            'name': 'Food industry'
        },
        {
            'id': '450aaadd-4a9f-4029-8869-d4a340156766',
            'name': 'Wine'
        }
    ],
    'id': 'ed2f5670-9351-4f2b-a5a3-1de8400c5e9d',
    'title': [
        'Freelance Writer'
    ],
    'sourceSnippets': [
        {
            'id': '1d5623a9-9aa9-4501-84fd-79ba531d776d',
            'name': 'The Wine Advocate',
            'mediaChannels': [
                {
                    'id': '19f41d06-8ada-42b3-9a89-4f3efe08b05d',
                    'name': 'Consumer Magazine'
                }
            ],
            'reachTier': 'tier_3',
            'newsFocus': 'National',
            'frequency': 'Twice a month'
        },
        {
            'id': '1f3e63cc-c4b6-416f-88e4-6180e0158ab6',
            'name': 'Bon Appétit',
            'mediaChannels': [
                {
                    'id': '19f41d06-8ada-42b3-9a89-4f3efe08b05d',
                    'name': 'Consumer Magazine'
                },
                {
                    'id': 'd8f66970-5deb-4d4c-ae82-c74f0c21b880',
                    'name': 'Online'
                }
            ],
            'reachTier': 'tier_1',
            'newsFocus': 'National',
            'frequency': 'Monthly'
        }
    ],
    'relevantArticles': 1
};

// This is the contact data model that is used on the client in icm-web and fairhair-web, see contact_manager_contact_model
let convertContactModel = {
    'id': 'ed2f5670-9351-4f2b-a5a3-1de8400c5e9d',
    'name': {
        'firstName': 'Rachel',
        'lastName': 'Tepper Paley',
        'middleName': '',
        'fullName': 'Rachel Tepper Paley'
    },
    'unsubscribed': false,
    'contactInfo': {
        'email': [
            {
                'address': 'ratepper@gmail.com',
                'unsubscribed': false
            }
        ],
        'phone': [
            {
                'type': 'work',
                'number': ''
            }
        ],
        'address': [
            {
                'city': 'New York',
                'stateOrProvince': 'New York',
                'country': 'United States',
                'isAddressEmpty': false
            }
        ]
    },
    'notes': [
        ''
    ],
    'channels': [
        {
            'type': 'LinkedIn',
            'url': 'https://www.linkedin.com/in/rachel-tepper-paley-0a40609'
        },
        {
            'type': 'Twitter',
            'url': 'https://twitter.com/racheltepper'
        },
        {
            'type': 'Facebook',
            'url': 'https://www.facebook.com/racheltepper'
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'instagram',
                'url': 'https://www.instagram.com/thepumpernickel/?hl=en'
            }
        },
        {
            'type': 'social',
            'socialProfile': {
                'type': 'googleplus',
                'url': 'https://plus.google.com/113424597791865604922'
            }
        },
        {
            'id': '1d5623a9-9aa9-4501-84fd-79ba531d776d',
            'name': 'The Wine Advocate',
            'mediaChannels': [
                {
                    'id': '19f41d06-8ada-42b3-9a89-4f3efe08b05d',
                    'name': 'Consumer Magazine'
                }
            ],
            'reachTier': 'tier_3',
            'newsFocus': 'National',
            'frequency': 'Twice a month',
            'type': 'Source'
        },
        {
            'id': '1f3e63cc-c4b6-416f-88e4-6180e0158ab6',
            'name': 'Bon Appétit',
            'mediaChannels': [
                {
                    'id': '19f41d06-8ada-42b3-9a89-4f3efe08b05d',
                    'name': 'Consumer Magazine'
                },
                {
                    'id': 'd8f66970-5deb-4d4c-ae82-c74f0c21b880',
                    'name': 'Online'
                }
            ],
            'reachTier': 'tier_1',
            'newsFocus': 'National',
            'frequency': 'Monthly',
            'type': 'Source'
        }
    ],
    'title': [
        'Freelance Writer'
    ],
    'description': '',
    'beats': [
        {
            'id': '33f6bff2-6c51-4b18-9712-e2d5ed85e267',
            'name': 'Food industry'
        },
        {
            'id': '450aaadd-4a9f-4029-8869-d4a340156766',
            'name': 'Wine'
        }
    ],
    'systemData': {},
    'mediaLists': [],
    'roles': [],
    'relevantArticles': 1,
    'updated': null
};




// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/media-contact-document.model.ts